import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-neutral-400" data-testid="auth-loading">
        Verifying session…
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
